import { OktaAuth } from '@okta/okta-auth-js';
import { oktaConfig } from './constants';

export const oktaHelper = new OktaAuth(oktaConfig);